import axios from "axios"
const BASE_URL = process.env.REACT_APP_API_URL

class CollegeApplicationApi {
    getCollegeApplications(config) {
        return axios.get(BASE_URL + "/application/institution-apply-list", config)
    }
}

export default new CollegeApplicationApi();
